if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousButton = this.querySelector('.product-media-modal__nav--previous');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');

        [this.previousButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.previousButton?.addEventListener('click', () => this.showAdjacentMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showAdjacentMedia(1));
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') this.showAdjacentMedia(-1);
          if (event.code === 'ArrowRight') this.showAdjacentMedia(1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showAdjacentMedia(direction) {
        const media = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        if (media.length < 2) return;

        const activeIndex = Math.max(
          0,
          media.findIndex((item) => item.classList.contains('active'))
        );
        const nextIndex = (activeIndex + direction + media.length) % media.length;

        window.pauseAllMedia();
        media.forEach((item) => item.classList.remove('active'));
        media[nextIndex].classList.add('active');
        media[nextIndex].focus?.({ preventScroll: true });

        if (media[nextIndex].nodeName === 'DEFERRED-MEDIA') {
          media[nextIndex].loadContent();
        }
      }
    }
  );
}
